import { SecurityUserDto } from "./security-user-dto.model";

export class SecurityDto {
  user: SecurityUserDto = new SecurityUserDto();
  roles: string[] = [];
  resources: string[] = [];
}